<template>
  <div class="container-fluid">
    <loading v-if="loadingRender"></loading>
    <h5>امضای سفته</h5>
    <div class="row">
      <ul>
        <li class="text-danger" v-for="(error, index) in ErrorList" :key="index">
          {{ error.message }}
        </li>
      </ul>
    </div>
    <div class="row">
      <div class="col-md-4 col-12">
        <small>امضای مورد نظر را برای سفته انتخاب کنید</small>
        <select class="form-control" @change="UpdateP12" v-model="SignData" name="Signs" id="Signs">
          <option v-for="(item, index) in SignList" :value="item" :key="index">{{ item.fa_last_name + ' ' + item.fa_first_name }}</option>
        </select>
      </div>
      <div class="col-md-4 col-12">
        <small>رمز امضای الکترونیک</small>
        <input type="password" v-model="Data.p12_password" dir="ltr" class="form-control text-center" />
      </div>
      <div class="col-md-2 col-12">
        <button class="btn btn-info mt-3"><a class="text-light" download="Safte.PDF" target="_blank" :href="'data:application/pdf;base64,' + SafteToSign.unsigned_data">مشاهده سفته</a></button>
      </div>
      <div class="col-md-2 w-100 mt-3 col-12">
        <button class="btn w-100 btn-success" @click="SubmitSafteFinally()">امضای سفته</button>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from '../../Tools/NetPa/Loading.vue'
export default {
  components: { Loading },
  data() {
    return {
      SignList: [],
      Data: {
        BnpInfo: {
          CustCode: this.$session.get('CustCode'),
          BnpToken: this.$session.get('TokenNetPa'),
          LoginCodeMelli: this.$session.get('UserInfoNetPa').codeMeli,
        },
        request_id: '',
        national_code: '',
        p12_password: '',
        p12_file: '',
      },
      SignData: {},
      ErrorList: [],
      loadingRender: false,
    }
  },
  props: ['SafteToSign'],
  methods: {
    GetList() {
      var GetParams = { method: 'GET', action: 'ElectronicSafte/' + this.$session.get('UserInfoNetPa').wwwtblAzaId, arryfildValue: null }
      this.$PostData_netpatoken(GetParams).then((result) => {
        if ((result.status = 'success')) {
          this.error = false
          this.SignList = result.data.filter((x) => x.certificate_status.trim() == 'صادر شد')
        } else {
          this.error = true
        }
      })
    },
    UpdateP12() {
      console.log(this.SignData)
      this.Data.national_code = this.SignData.national_code.trim()
      this.Data.p12_file = this.SignData.p12_file.trim()
    },
    SubmitSafteFinally() {
      if (this.Data.p12_file == null || this.Data.p12_file == '') {
        this.$mySweetDefaultTost('هشدار', 'هیچ امضایی انتخاب نشده است', 'error', 2500)
      }
      if (this.Data.p12_password == null || this.Data.p12_password == '') {
        this.$mySweetDefaultTost('هشدار', 'رمز امضای الکترونیک خود را وارد نکرده اید', 'error', 2500)
      } else {
        this.loadingRender = true
        var DataAxios = { method: 'post', action: 'ElectronicSafte/Sign_finally', arryfildValue: this.Data }
        console.log(DataAxios)
        this.$PostData_netpatoken(DataAxios)
          .then((result) => {
            if (result.status == 'success') {
              this.$mySweetDefaultTost('عملیات موفق', 'سفته با موفقیت امضا شد', 'success', 2500)
              this.$emit('SignDone', null)
            } else {
              this.ErrorList = result.errors
            }
          })
          .finally(() => {
            this.loadingRender = false
          })
      }
    },
  },
  created() {
    this.GetList()
    this.Data.request_id = this.SafteToSign.request_id.trim()
  },
}
</script>
